import PropTypes from 'prop-types';
import MuiMenuItem from '@mui/material/MenuItem';
import BaseComponent from "../../../../lib/components/BaseComponent";

class MenuItem extends BaseComponent {

    onClick = (e) => {
        if (this.props.onClick !== undefined) {
            this.props.onClick(e, this.props.value);
        }
    }

    render() {
        const { value, children, sx, ...otherProps } = this.props;
        return <MuiMenuItem
            {...otherProps}
            value={value}
            onClick={(e) => {
                if (otherProps.onClick) {
                    otherProps.onClick(e);
                }
                this.onClick(e)
            }}
            sx={{ display: 'flex', gap: 1 }}>
            {children}
        </MuiMenuItem>;
    }
}

MenuItem.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    value: PropTypes.any
}
export default MenuItem;
